"use strict";

var debounce = require("lodash/debounce");
var endpoint = $(".suggestions-wrapper").data("url");
var minChars = 1;
var UP_KEY = 38;
var DOWN_KEY = 40;
var DIRECTION_DOWN = 1;
var DIRECTION_UP = -1;

/**
 * Retrieves Suggestions element relative to scope
 *
 * @param {Object} scope - Search input field DOM element
 * @return {JQuery} - .suggestions-wrapper element
 */
function getSuggestionsWrapper(scope) {
    return $(scope).siblings(".suggestions-wrapper");
}

/**
 * Determines whether DOM element is inside the .search-mobile class
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 * @return {boolean} - Whether DOM element is inside  div.search-mobile
 */
function isMobileSearch(scope) {
    return !!$(scope).closest(".search-mobile").length;
}

/**
 * Remove modal classes needed for mobile suggestions
 *
 */
function clearModals() {
    $("body").removeClass("modal-open");
    $("header").siblings().attr("aria-hidden", "false");
    $(".suggestions").removeClass("modal");
}

/**
 * Apply modal classes needed for mobile suggestions
 *
 * @param {Object} scope - Search input field DOM element
 */
function applyModals(scope) {
    if (isMobileSearch(scope)) {
        $("body").addClass("modal-open");
        $("header").siblings().attr("aria-hidden", "true");
        getSuggestionsWrapper(scope).find(".suggestions").addClass("modal");
    }
}

/**
 * Tear down Suggestions panel
 */
function tearDownSuggestions() {
    $("input.search-field").val("");
    clearModals();
    $(".search-mobile .suggestions").unbind("scroll");
    $(".suggestions-wrapper").empty();
}

/**
 * Toggle search field icon from search to close and vice-versa
 *
 * @param {string} action - Action to toggle to
 */
function toggleSuggestionsIcon(action) {
    var mobileSearchIcon = ".search-mobile button.";
    var iconSearch = "fa-search";
    var iconSearchClose = "fa-close";

    if (action === "close") {
        $(mobileSearchIcon + iconSearch).removeClass(iconSearch).addClass(iconSearchClose).attr("type", "button");
    } else {
        $(mobileSearchIcon + iconSearchClose).removeClass(iconSearchClose).addClass(iconSearch).attr("type", "submit");
    }
}

/**
 * Determines whether the "More Content Below" icon should be displayed
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function handleMoreContentBelowIcon(scope) {
    if (($(scope).scrollTop() + $(scope).innerHeight()) >= $(scope)[0].scrollHeight) {
        $(".more-below").fadeOut();
    } else {
        $(".more-below").fadeIn();
    }
}

/**
 * Positions Suggestions panel on page
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function positionSuggestions(scope) {
    var outerHeight;
    var $scope;
    var $suggestions;
    var top;

    if (isMobileSearch(scope)) {
        $scope = $(scope);
        top = $scope.offset().top;
        outerHeight = $scope.outerHeight();
        $suggestions = getSuggestionsWrapper(scope).find(".suggestions");
        $suggestions.css("top", top + outerHeight);

        handleMoreContentBelowIcon(scope);

        // Unfortunately, we have to bind this dynamically, as the live scroll event was not
        // properly detecting dynamic suggestions element's scroll event
        $suggestions.scroll(function () {
            handleMoreContentBelowIcon(this);
        });
    }
}

/**
 * Process Ajax response for SearchServices-GetSuggestions
 *
 * @param {Object|string} response - Empty object literal if null response or string with rendered
 *                                   suggestions template contents
 */
function processResponse(response) {
    var $suggestionsWrapper = getSuggestionsWrapper(this).empty();

    $.spinner().stop();

    if (typeof (response) !== "object") {
        $suggestionsWrapper.append(response).show();
        $(this).siblings(".reset-button").addClass("d-sm-block");
        positionSuggestions(this);

        if (isMobileSearch(this)) {
            toggleSuggestionsIcon("close");
            applyModals(this);
        }

        // Trigger screen reader by setting aria-describedby with the new suggestion message.
        var suggestionsList = $(".suggestions .item");
        if ($(suggestionsList).length) {
            $("input.search-field").attr("aria-describedby", "search-result-count");
        } else {
            $("input.search-field").removeAttr("aria-describedby");
        }
    } else {
        $suggestionsWrapper.hide();
    }
}

/**
 * Retrieve suggestions
 *
 * @param {Object} scope - Search field DOM element
 */
function getSuggestions(scope) {
    if ($(scope).val().length >= minChars) {
        var isForVehicleSelector = !!$(scope).closest(".vehicle-selector-searcher").length;

        $.spinner().start();
        $.ajax({
            context: scope,
            url: endpoint + encodeURIComponent($(scope).val()) + "&isForVehicleSelector=" + isForVehicleSelector,
            method: "GET",
            success: processResponse,
            error: function () {
                $.spinner().stop();
            }
        });
    } else {
        toggleSuggestionsIcon("search");
        $(scope).siblings(".reset-button").removeClass("d-sm-block");
        clearModals();
        getSuggestionsWrapper(scope).empty();
    }
}

/**
 * Handle Search Suggestion Keyboard Arrow Keys
 *
 * @param {Integer} direction takes positive or negative number constant, DIRECTION_UP (-1) or DIRECTION_DOWN (+1)
 */
function handleArrow(direction) {
    // get all li elements in the suggestions list
    var suggestionsList = $(".suggestions .item");
    if (suggestionsList.filter(".selected").length === 0) {
        suggestionsList.first().addClass("selected");
        $("input.search-field").each(function () {
            $(this).attr("aria-activedescendant", suggestionsList.first()[0].id);
        });
    } else {
        suggestionsList.each(function (index) {
            var idx = index + direction;
            var $this = $(this);
            if ($this.hasClass("selected")) {
                $this.removeClass("selected");
                $this.removeAttr("aria-selected");
                if (suggestionsList.eq(idx).length !== 0) {
                    suggestionsList.eq(idx).addClass("selected").attr("aria-selected", true);
                    $this.removeProp("aria-selected");
                    $("input.search-field").each(function () {
                        $(this).attr("aria-activedescendant", suggestionsList.eq(idx)[0].id);
                    });
                } else {
                    suggestionsList.first().addClass("selected");
                    suggestionsList.first().attr("aria-selected", true);
                    $("input.search-field").each(function () {
                        $(this).attr("aria-activedescendant", suggestionsList.first()[0].id);
                    });
                }
                return false;
            }
            return true;
        });
    }
}

/**
 * Resolves the search location based on where the search form is rendered.
 *
 * @param {HTMLElement} form - Search form element
 * @returns {string} - Search location
 */
function resolveSearchLocation(form) {
    var $form = $(form);

    if ($form.closest(".vehicle-selector-searcher").length) {
        return "second_search";
    }

    if ($form.closest(".search-mobile").length) {
        return "model_search";
    }

    return "global_search";
}

/**
 * Ensures a hidden input exists in the form and updates its value.
 *
 * @param {JQuery} $form - Form element
 * @param {string} fieldName - Hidden input name
 * @param {string} fieldValue - Hidden input value
 */
function upsertHiddenField($form, fieldName, fieldValue) {
    var $field = $form.find("input[type='hidden'][name='" + fieldName + "']");

    if (!$field.length) {
        $field = $("<input>", {
            type: "hidden",
            name: fieldName
        }).appendTo($form);
    }

    $field.val(fieldValue || "");
}

/**
 * Appends or replaces query params in URL.
 *
 * @param {string} url - Destination URL
 * @param {Object} params - Key-value pairs to set
 * @returns {string} - URL with query params
 */
function appendParamsToUrl(url, params) {
    if (!url) {
        return url;
    }

    var urlParts = url.split("#");
    var baseAndQuery = urlParts[0];
    var hash = urlParts.length > 1 ? "#" + urlParts.slice(1).join("#") : "";
    var queryStart = baseAndQuery.indexOf("?");
    var base = queryStart >= 0 ? baseAndQuery.substring(0, queryStart) : baseAndQuery;
    var query = queryStart >= 0 ? baseAndQuery.substring(queryStart + 1) : "";
    var searchParams = new URLSearchParams(query);

    Object.keys(params || {}).forEach(function (key) {
        if (params[key] !== undefined && params[key] !== null && params[key] !== "") {
            searchParams.set(key, params[key]);
        }
    });

    var finalQuery = searchParams.toString();
    return base + (finalQuery ? "?" + finalQuery : "") + hash;
}

export default function searchSuggestions() {
    $("form[name='simpleSearch']").submit(function (e) {
        var $form = $(this);
        var searchLocation = resolveSearchLocation(this);
        var suggestionsList = $(".suggestions .item");

        if (suggestionsList.filter(".selected").length !== 0) {
            e.preventDefault();
            suggestionsList.filter(".selected").find("a")[0].click();
            return;
        }

        upsertHiddenField($form, "search_location", searchLocation);
        upsertHiddenField($form, "search_type", "direct");
    });

    $("body").on("click", "form[name='simpleSearch'] .suggestions .item a", function () {
        var $anchor = $(this);
        var $form = $anchor.closest("form[name='simpleSearch']");
        var searchLocation = resolveSearchLocation($form.get(0));

        $anchor.attr("href", appendParamsToUrl($anchor.attr("href"), {
            search_location: searchLocation,
            search_type: "recommendation"
        }));
    });

    $("input.search-field").each(function () {
        /**
         * Use debounce to avoid making an Ajax call on every single key press by waiting a few
         * hundred milliseconds before making the request. Without debounce, the user sees the
         * browser blink with every key press.
         */
        var debounceSuggestions = debounce(getSuggestions, 300);
        $(this).on("keyup focus", function (e) {
            // Capture Down/Up Arrow Key Events
            switch (e.which) {
                case DOWN_KEY:
                    handleArrow(DIRECTION_DOWN);
                    e.preventDefault(); // prevent moving the cursor
                    break;
                case UP_KEY:
                    handleArrow(DIRECTION_UP);
                    e.preventDefault(); // prevent moving the cursor
                    break;
                default:
                    debounceSuggestions(this, e);
            }
        });
    });

    $("body").on("click", function (e) {
        if (!$(".suggestions").has(e.target).length && !$(e.target).hasClass("search-field")) {
            $(".suggestions").hide();
        }
    });

    $("body").on("click touchend", ".search-mobile button.fa-close", function (e) {
        e.preventDefault();
        $(".suggestions").hide();
        toggleSuggestionsIcon("search");
        tearDownSuggestions();
    });

    $(".site-search .reset-button").on("click", function () {
        $(this).removeClass("d-sm-block");
    });
}
